import { API_BASE_URL } from './api';

const getWsUrl = () => {
    // Если API_BASE_URL пустой или относительный, используем текущий хост
    let baseUrl = API_BASE_URL;
    if (!baseUrl || baseUrl.startsWith('/')) {
        const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        const host = window.location.host;
        baseUrl = `${protocol}//${host}`;
    } else {
        baseUrl = baseUrl.replace('http', 'ws');
    }
    
    // Удаляем лишние слэши в конце и добавляем путь
    return `${baseUrl.replace(/\/$/, '')}/ws/notifications/`;
};

/**
 * Подписка на уведомления через WebSocket с автоматическим переподключением
 */
export const subscribeToNotifications = (onNotification) => {
    let socket = null;
    let reconnectTimeout = null;
    let reconnectAttempts = 0;
    const maxReconnectDelay = 30000; // Максимум 30 секунд

    const connect = () => {
        const wsUrl = getWsUrl();
        console.log(`Connecting to WebSocket: ${wsUrl}`);
        
        // Токен больше не передается в URL, так как бэкенд читает его из Cookies (HttpOnly)
        socket = new WebSocket(wsUrl);

        socket.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                onNotification(data);
            } catch (e) {
                console.error('Error parsing notification:', e);
            }
        };

        socket.onopen = () => {
            console.log('Notification WebSocket connected');
            reconnectAttempts = 0; // Сбрасываем счетчик при успешном подключении
        };

        socket.onclose = (event) => {
            console.log(`Notification WebSocket closed (code: ${event.code}). Reconnecting...`);
            
            // Не переподключаемся, если закрытие было намеренным (код 1000)
            if (event.code !== 1000) {
                const delay = Math.min(1000 * Math.pow(2, reconnectAttempts), maxReconnectDelay);
                reconnectAttempts++;
                reconnectTimeout = setTimeout(connect, delay);
            }
        };

        socket.onerror = (error) => {
            console.error('Notification WebSocket error:', error);
            socket.close(); // Триггерим onclose для переподключения
        };
    };

    connect();

    // Возвращаем объект управления
    return {
        close: () => {
            if (reconnectTimeout) clearTimeout(reconnectTimeout);
            if (socket) {
                socket.onclose = () => {}; // Отключаем логику переподключения
                socket.close(1000);
            }
        }
    };
};
